import request from '../../axios';

const getDetailShopCard = async (payload: IPayload) => {
  if (!payload?.guid) throw new Error('guid is required');
  
  const params = new URLSearchParams({guid: payload.guid});
  if (payload.page_size) {
    params.append('page_size', String(payload.page_size));
  }

  const {data}: {data: IShopCardDetail} = await request.get(
    `api/v2/store/store-redesign-view?${params.toString()}`,
  );

  return data;
};

export default getDetailShopCard;
